<div class="row mb-20">
  <div class="col-sm-12" *ngIf="controparti && controparti.length > 0">
    <p>Controparti associate :</p>
    <list-controparti 
      [fascicolo]="fascicolo" 
      [sezione]="sezione"
      [writable]="isFascicoloWritable"
      (onDocumentEvent)="onDocumentEvent($event)"
      (onDropDownEvent)="onDropDownEvent($event)" 
      (onDelete)="onDeleteControparte($event)" 
      (onReturn)="retrieveControparte($event)">
    </list-controparti>
  </div>
</div>

<div class="row">
  <!-- <div class="col-sm-12" *ngIf="!suggested || suggested.length === 0">
    <h5>Nessuna parte suggerita</h5>
  </div> -->
  <div class="col-sm-12" *ngIf="suggested && suggested.length > 0">
    <h5>Parti suggerite :</h5>
    <list-parti (actionEmitter)="action = $event" [action] = "action" [labelComponent] = "'suggested'" *ngIf="suggested.length > 0" [optionsList] = "suggested"></list-parti>
  </div>
</div>

<div class="row">
  <div class="col-sm-12">
    <div class="container_tab_nav">

      <!-- Tablist -->
      <ul class="nav nav-tabs two" role="tablist" aria-label="Ricerca e inserimento parti">
        <li role="presentation" class="tab-link-nav" [style.width.%]="50">
          <button
            role="tab"
            type="button"
            id="tab-0-parti"
            class="btn-link"
            [attr.aria-selected]="activeTab === 0"
            [attr.aria-controls]="'tabpanel-0-parti'"
            [class.active]="activeTab === 0"
            [class.inactive]="activeTab !== 0"
            (click)="activeTab = 0">
              Cerca
          </button>
        </li>

        <li role="presentation" class="tab-link-nav" [style.width.%]="50">
          <button
            role="tab"
            type="button"
            id="tab-1-parti"
            class="btn-link"
            [attr.aria-selected]="activeTab === 1"
            [attr.aria-controls]="'tabpanel-1-parti'"
            [class.active]="activeTab === 1"
            [class.inactive]="activeTab !== 1"
            (click)="activeTab = 1">
              Inserisci
          </button>
        </li>
      </ul>

      <!-- Tab panels -->
      <div class="tab-content">
        <!-- Pannello Cerca -->
        <div
          role="tabpanel"
          id="tabpanel-0-parti"
          [attr.aria-labelledby]="'tab-0-parti'"
          [hidden]="activeTab !== 0"
          class="tab-pane fade"
          [class.active]="activeTab === 0"
          [class.in]="activeTab === 0"
        >
          <div
            searchTextInput
            #searchElement
            [url]="requestSearchUrl"
            (onReturn)="retrieveSearch($event)"
            (keyup)="onSearchChange(searchElement.valueSearch)"
          ></div>

          <list-parti
            (onReturn)="retrieveControparte($event)"
            (emitParte)="retrieveParte($event)"
            (actionEmitter)="action = $event"
            [action]="action"
            [labelComponent]="'search'"
            [optionsList]="options"
            [totali]="totalResults"
            (requestMore)="reloadSearch()"
          ></list-parti>
        </div>

        <!-- Pannello Inserisci -->
        <div
          role="tabpanel"
          id="tabpanel-1-parti"
          [attr.aria-labelledby]="'tab-1-parti'"
          [hidden]="activeTab !== 1"
          class="tab-pane fade"
          [class.active]="activeTab === 1"
          [class.in]="activeTab === 1"
        >
          <step-parti-form-inserimento
            (onParteReturn)="onParteInsert($event)"
            (controparteChange)="retrieveControparte($event)"
          ></step-parti-form-inserimento>
          
        </div>
      </div>
    </div>
  </div>
</div>


<div [attr.id]="'docAddModalParti'" doc_add_modal style="width: 100%;height: 100vh;margin: 0px;" #docAddModalParti [fascicolo]="fascicolo" (onReturn)="closeModalDocumentAndReadSezione()"></div>

<div doc_version_update_modal  #docVersionUpdateModalParti [attr.id]="'docVersionUpdateModalParti'" [fascicolo]="fascicolo" (onReturn)="closeModalDocumentAndReadSezione()" style="width: 80%;"></div>

<div doc_version_history_modal #docVersionHistoryParti [tipoPratica]="fascicolo?.praticaBase?.tipoPratica.id" [attr.id]="'docVersionHistoryParti'"></div>


<!-- <div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
  </p>
  <p
    class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block' [disabled]="controparteTmp === null" (click)="salva()">
      Salva
    </button>
  </p>
</div> -->

